import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const Row = ({ label, value, highlight }) => (
  <Box display="flex" justifyContent="space-between" mt={1.5} >
    <Typography
      variant="subtitle2"
      fontWeight="600"
      color={highlight ? "primary" : "text.secondary"}
    >
      {label}
    </Typography>
    <Typography
      variant="subtitle2"
      fontWeight="600"
      color={highlight ? "primary" : "text.secondary"}
      sx={highlight ? { color: "#ffb300" } : {}}
    >
      {value}
    </Typography>
  </Box>
);

const CouponRewardCard = ({ type, grandTotal, amount, mvName, cashbackCount,fullObjectRewardCart }) => {
  //logger.log("fullObjectRewardCart",fullObjectRewardCart?.data?.items)
  const isLoading = !fullObjectRewardCart;
  const totalAmount =
  fullObjectRewardCart?.data?.items &&
  fullObjectRewardCart?.data?.items.reduce(
      (accumulator, item) => accumulator + item.amount * item.count,
      0
    );
  
  const data=fullObjectRewardCart&&fullObjectRewardCart?.data?.reward
   const items=fullObjectRewardCart&&fullObjectRewardCart?.data?.items
   const reward=fullObjectRewardCart&&fullObjectRewardCart?.data?.reward
  //logger.log("couponReward2",fullObjectRewardCart,data,items)
 //logger.log("items-------",items)
 //logger.log(" fullObjectRewardCart?.data?.items", fullObjectRewardCart?.data?.items)
/* 
  const totalDiscountedAmount =fullObjectRewardCart?.data?.items.reduce(
  (sum, item) => sum + (item.discountedAmount || 0),
  0

); */


const totalDiscountedAmount = fullObjectRewardCart?.data?.items?.reduce(
  (sum, item) => sum + (item.discountedAmount ?? item.amount ?? 0),
  0
);
const totalCashBackAmount =
   fullObjectRewardCart?.data?.items&&
   fullObjectRewardCart?.data?.items.reduce(
    (sum, item) => sum + (item.amount || 0) * (item.count || 1),
    0
  );


  const totalWithoutCoupon =
   fullObjectRewardCart?.data?.items &&
   fullObjectRewardCart?.data?.items.reduce(
    (sum, item) => sum + (item.amount || 0) * (item.count || 1),
    0
  );

  return (

    <Card
      sx={{
        borderRadius: 2,
        boxShadow: 2,
        bgcolor: "white",
        mt: 2,
        mb: 4,
      }}
    >
      <CardContent>
        {}
        {/* Always show Grand Total */}

       
          {data==null&&<Row label="Grand Total" value={isLoading ? "Calculating..." : `₹ ${totalAmount?.toFixed(2)}`} highlight />}

       {reward&&reward.type =="discount" && (
          <>
    
            <Row label="Grand Total" value={`₹ ${totalDiscountedAmount?.toFixed(2)}`} />
          </>
        )}
{/*       
 */}
        {reward&&reward.type === "freegift" && (
          <>
            <Row label="Free Gift added" value="" highlight />
            <Row label={mvName} value={`₹ ${amount?.toFixed(2)}`} />
          </>
        )}

        {reward&&reward.type === "cashback" && (
          <>
             <Row label="Grand Total" value={`₹ ${totalCashBackAmount?.toFixed(2)}`} />
            <Row label="Cashback Earned" value="" highlight />
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary" width={"80%"}>
                Cashback will be added to your Daalchini Points Wallet after Pickup
              </Typography>
              <Typography variant="body2" sx={{ color: "#ffb300" }}>
                + {reward.count?.toFixed(2)}
              </Typography>
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default CouponRewardCard;
